import { site } from "../content";

export default function TopBar() {
  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] flex h-8 items-center justify-center border-b border-white/5 bg-ink/90 px-4 backdrop-blur-md"
      data-testid="top-bar"
    >
      <p className="truncate text-[10px] font-medium uppercase tracking-[0.3em] text-bone/60 sm:text-[11px]">
        {site.topBar.join("   •   ")}
      </p>
    </div>
  );
}
